module.exports = __webpack_public_path__ + "img/edit_user_tags_user.f4b94f70.png";